export const productName = 'MEGAPACK ASTRONOMÍA LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/czSVzPcYkBMwh5q1XmyC7q/MOCKUP.png';

export const checkoutUrl = 'https://megapack-astronomia-listo.impultienda.ar/checkout';

export const price = '$19.990 ARS';
export const priceBefore = '$119.000 ARS';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = '$76.000 ARS';

export const baseItems = [
  'TOMO 1: Fundamentos de Astronomía para la Enseñanza',
  'TOMO 2: El Sistema Solar Completo',
  'TOMO 3: Tierra, Sol y Luna',
  'TOMO 4: Estrellas, Constelaciones y Observación del Cielo',
  'TOMO 5: Galaxias, Vía Láctea y Universo Profundo',
  'TOMO 6: Cosmología, Origen y Evolución del Universo',
  'TOMO 7: Exoplanetas y Búsqueda de Vida en el Universo',
  'TOMO 8: Exploración Espacial, Misiones y Tecnología Astronómica',
  'TOMO 9: Astronomía en el Aula',
  'BONO 1: Banco de 150 Actividades de Astronomía Listas para el Aula',
  'BONO 2: Kit Completo de Evaluación de Astronomía — 60 Instrumentos',
  'BONO 3: Banco de 100 Proyectos de Astronomía para el Aula',
  'BONO 4: Atlas Visual de Astronomía para el Aula',
  'BONO 5: 100 Mitos, Errores y Preguntas Difíciles de Astronomía para el Aula',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% científico actualizado', 'Datos astronómicos vigentes, contexto del cielo austral, referencias a investigaciones recientes y casos de descubrimientos actuales.'],
  ['Material imprimible', 'Listo para usar en el aula o entregar directamente al alumno.'],
  ['Formularios y plantillas reales', 'Proyectos de observación, registros de datos y reportes científicos adaptados a 2026.'],
  ['Casos prácticos resueltos paso a paso', 'Con datos reales de fenómenos astronómicos observables desde Argentina.'],
  ['Vocabulario técnico explicado', 'Sin jerga innecesaria, accesible para todos los niveles educativos.'],
  ['Conexión con la actualidad', 'Misiones espaciales actuales, descubrimientos de exoplanetas, IA en análisis astronómico y telescopios de última generación.'],
  ['Observación del cielo austral', 'Especialmente diseñado para docentes del hemisferio sur que enseñan en Argentina.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra.'],
  ['Actualizaciones gratuitas', 'Acceso de por vida al material.'],
];
